(ns frontend.test.search-selector.view
  (:require
   [reagent.core :as r]
   [re-frame.core :as rf]
   [common.localization :as loc]
   [common.util :as cu]
   [ui.components.button.view :as button]
   [ui.components.search-selector.components.searchbox :as searchbox]
   [ui.components.search-selector.components.recent :as recent]
   [ui.components.search-selector.components.result :as result]
   [frontend.view.components.power-search.key-hint.view :as key-hint]
   [frontend.test.search-selector.event]
   [frontend.test.search-selector.sub]
   [frontend.test.search-selector.model :as m]
   [ui.dom-globals :as dg]
   [ui.util :as uu]
   [ui.view.page.view :as page]))

(defn results-view
  [{:keys [results-query* query* query-loading?* results-by-et*
           on-result-click]}]
  [:div
   {:class (uu/cm "flex-1")}
   [:div
    {:class (uu/cm "flex flex-col gap-6 p-4")}
    (when @query-loading?*
      [:div
       {:class (uu/cm "px-2")}
       "Loading..."])
    (cond
      (and (not @query-loading?*)
           (some? @results-query*)
           (empty? @results-by-et*))
      [:div (loc/tr :search-no-results-for [@results-query*])]

      (seq @results-by-et*)
      [:div
       (when-not (cu/blank-value? @results-query*)
         [:div
          {:class (uu/cm "pb-2")}
          (str "Results for '" @results-query* "':")])
       (doall
        (for [[index [et hits]] (mapv vector (range)
                                      @results-by-et*)]
          ^{:key (str et)}
          [result/result-group
           {:icon-class "fa-user"
            :title (loc/tr et)
            :section-index (inc index)
            :on-result-click on-result-click
            :visible-hits hits}]))]

      :else
      nil)]])

(defn recents-view
  [{:keys [recently-selected*
           on-remove-recently-selected] :as args}]
  (let [recently-selected @recently-selected*]
    [:div
     {:class (uu/cm "mb-0 hidden md:flex flex-col w-[300px] text-sm"
                    "border-l border-solid border-base-light-border-paler")}
     [:div
      {:class (uu/cm "p-3 flex flex-col gap-2 flex-1")}
      [:h2
       {:class "pb-2 text-base-light-text font-bold text-xl"}
       (loc/tr :recently-selected)]
      (if (empty? recently-selected)
        [:div
         {:class "text-base-light-text-paler"}
         (loc/tr :no-items)]
        (->> recently-selected
             (map-indexed
              (fn [i {:keys [id] :as result}]
                ^{:key (str (:db/id result) "-" id)}
                [recent/selected
                 {:result    result
                  :tab-index (+ 10100 i)
                  :on-remove (fn [_e]
                               (on-remove-recently-selected id))

                 ;;:active?   (and (= 0 i) input-focused?)
                  }]))))]]))

(defn below-section
  [args]
  [:div
   {:class "flex-1 overflow-auto"}
   [:div
    {:class (uu/cm "min-h-[440px] flex gap-3")}
    [results-view args]
    [recents-view args]]])

(def timeouts
  (atom {}))

(comment

  ;; to reduce the number of opensearch queries
  ;;  we can wrap the call in debounce
  ;; note: ended up using re-frame effect :ui.fx.timeout/timeout instead
  (defn debounce
    [f id ms]
    (fn [& args]
      (let [t (get @timeouts id)]
        (when t
          (swap! timeouts dissoc id)
          (js/clearTimeout t))
        (swap! timeouts
               assoc
               id (js/setTimeout
                   (fn []
                     (swap! timeouts dissoc id)
                     (apply f args))
                   ms))
        nil)))

  (def test-fn
    (debounce (fn [a] (prn "testing" a)) "some-id" 1000))

  (test-fn "hello")

  :rcb)

(defn searchbox-spike
  [{:keys [state*]}]
  (r/with-let [searchbox-id "searchbox-spike"
               ident [:spike]
               args {:ident ident}
               local-state (r/cursor state* [:spike])
               open! (fn []
                       (swap! local-state assoc :expanded? true))
               unfocus! (fn []
                          (some-> searchbox-id
                                  dg/element-by-id
                                  (.blur)))
               recently-selected* (r/cursor local-state [:recently-selected])
               remove-recently-selected! (fn [id]
                                           (swap! recently-selected*
                                                  (partial cu/remove-by :id id)))
               select-result! (fn [id]
                                (prn "selected" id))
               close! (fn []
                        (swap! local-state
                               (fn [state]
                                 (-> state
                                     (assoc
                                      :expanded? false
                                      :show-results? false)
                                     (dissoc :query))))
                        (rf/dispatch-sync [m/update-query args nil])
                        (unfocus!))
               query* (rf/subscribe [m/query args])
               results-query* (rf/subscribe [m/results-query args])
               update-query (fn [val]
                              (swap! local-state assoc
                                     :show-results? true)
                              (rf/dispatch-sync [m/search args val]))
               query-loading?* (rf/subscribe [m/query-loading? args])
               results-by-et* (rf/subscribe [m/results-by-et args])]
    (let [{:keys [expanded? show-results?]} @local-state]
      [:div
       {:class (uu/cm "flex flex-col gap-3")}
       [:div "Searchbox spike "]
       [:div
        {:class (uu/cm "md:w-[896px] max-w-full flex flex-col"
                       (when expanded?
                         "bg-base-light rounded max-h-screen shadow"))}
        [searchbox/view
         {:dom-id searchbox-id
          :placeholder (when-not expanded?
                         "Select")
          :class (when-not expanded?
                   (uu/cm "py-3 w-48 flex justify-between relative"
                          "border border-solid border-base-light-border-paler"))
          :input-class (when-not expanded?
                         (uu/cm "w-full pl-4 border-none focus:outline-none focus:shadow-none"))
          :query @query*
          :on-focus open!
          :on-click open!
          :on-blur (fn [val]
                     (prn "blurred" val))
          :on-change update-query #_(fn [val]
                                      (swap! local-state assoc
                                             :show-results? true
                                             :query val))
          :on-esc close!
          :right (when expanded?
                   [:div
                    {:class "pr-3 flex gap-2 items-center *:p-0"}
                    [key-hint/key-hint {:small? true} (loc/tr :shortcut-esc)]
                    [button/secondary-open
                     {:on-click
                      close!}
                     [:i.fal.fa-times]]])
          :left (when expanded?
                  [:div
                   {:class "m-0 flex items-center absolute left-3 top-4 text-md"}
                   [:i.fal.fa-search]])}]
        (when show-results?
          [below-section
           {:query* query*
            :results-query* results-query*
            :on-remove-recently-selected
            remove-recently-selected!
            :on-result-click select-result!
            :recently-selected* recently-selected*
            :query-loading?* query-loading?*
            :results-by-et* results-by-et*}])]])
    (finally
      #_(prn ">cleanup"))))

(defn searchbox-test
  [{:keys [state*]}]
  (r/with-let [searchbox-id "searchbox-test"
               focus! (fn []
                        (some-> searchbox-id
                                dg/element-by-id
                                (.focus)))]
    (let [{:keys [left right open?]} @state*]
      [:div
       {:class (uu/cm "flex flex-col gap-3")}
       [:div "Searchbox. Hide left: "
        [:input
         {:type "checkbox"
          :class "mr-2"
          :on-change (fn [_e]
                       (swap! state* update :left not))}]
        "Hide right: "
        [:input
         {:type "checkbox"
          :on-change (fn [_e]
                       (swap! state* update :right not))}]]
       [searchbox/view
        {:dom-id searchbox-id
         :placeholder "Custom placeholder"
         :auto-focus? true
         :on-blur (fn [val]
                    (prn "blurred" val))
         :on-change (fn [val]
                      (prn "changed" val))
         :right (when right
                  [:div
                   {:class "pr-3 flex gap-2 items-center *:p-0"}
                   [key-hint/key-hint {:small? true} (loc/tr :shortcut-esc)]
                   [button/secondary-open
                    {:on-click
                     (fn []
                       (prn ">close"))}
                    [:i.fal.fa-times]]])
         :left (when left
                 [:div
                  {:class "m-0 flex items-center absolute left-3 top-4 text-md"}
                  [:i.fal.fa-search]])}]])
    (finally
      #_(prn ">cleanup"))))

(defn expandable-searchbox-test
  [{:keys [state*]}]
  (r/with-let [open! (fn []
                       (swap! state* assoc :open? true))
               searchbox-id "searchbox-test-2"
               focus! (fn []
                        (some-> searchbox-id
                                dg/element-by-id
                                (.focus)))
               unfocus! (fn []
                          (some-> searchbox-id
                                  dg/element-by-id
                                  (.blur)))
               open-and-focus! (fn []
                                 (open!)
                                 (r/after-render focus!))
               close! (fn []
                        (swap! state* assoc :open? false)
                        (unfocus!))
               ;;
               #_#_on-key-down (fn [e]
                                 (when (= "Escape" (dg/event-key e))
                                   (prn ">close")))]
    (let [{:keys [left right open?]} @state*]
      [:div
       {:class (uu/cm "flex flex-col gap-3")}
       [:div "Click searchbox to expand"]
       [searchbox/view
        {:dom-id searchbox-id
         :placeholder (when-not open?
                        "Select")
         :class (when-not open?
                  (uu/cm "py-3 w-48 flex justify-between relative"
                         "border border-solid border-base-light-border-paler"))
         :input-class (when-not open?
                        (uu/cm "w-full pl-4 border-none focus:outline-none focus:shadow-none"))
         :on-focus open!
         :on-click open!
         :on-blur (fn [val]
                    (prn "blurred" val))
         :on-change (fn [val]
                      (prn "changed" val))
         :on-esc close!
         :right (when open?
                  [:div
                   {:class "pr-3 flex gap-2 items-center *:p-0"}
                   [key-hint/key-hint {:small? true} (loc/tr :shortcut-esc)]
                   [button/secondary-open
                    {:on-click
                     close!}
                    [:i.fal.fa-times]]])
         :left (when open?
                 [:div
                  {:class "m-0 flex items-center absolute left-3 top-4 text-md"}
                  [:i.fal.fa-search]])}]])
    (finally
      (prn ">cleanup"))))

(defn recently-selected-test
  [{:keys [state*]}]
  [:div
   {:class (uu/cm "flex flex-col gap-3")}
   [:div "Recently-selected: "]
   [recent/selected
    {:id 123321
     :dom-id "recently-selected-test"
     :tab-index 35
     :icon-class "fa-user-tie"
     :title "Investor"
     :display-name "Yhden Firman Investor Profile"
     :on-select (fn [id]
                  (prn "selected" id))
     :on-remove (fn [id]
                  (prn "remove" id))}]
   [recent/selected
    {:id 234432
     :dom-id "recently-selected-test-2"
     :tab-index 36
     :icon-class "fa-user-tie"
     :title "Investor"
     :display-name "Investor Profile [active]"
     :active? true
     :on-select (fn [id]
                  (prn "selected" id))
     :on-remove (fn [id]
                  (prn "remove" id))}]])

(defn recent-search-test
  [{:keys [state*]}]
  [:div
   {:class (uu/cm "flex flex-col gap-3")}
   [:div "Recent-search: "]
   [recent/search
    {:id "random"
     :dom-id "recent-search"
     :tab-index 37
     :icon-class "fa-user-tie"
     :query "aa ee ii oo"
     :on-select (fn [id]
                  (prn "selected" id))
     :on-remove (fn [id]
                  (prn "remove" id))}]
   [recent/search
    {:id "random-2"
     :dom-id "recent-search-2"
     :tab-index 38
     :icon-class "fa-user-tie"
     :query "something else [active]"
     :active? true
     :on-select (fn [id]
                  (prn "selected" id))
     :on-remove (fn [id]
                  (prn "remove" id))}]])

(defn result-test
  [{:keys [state*]}]
  [:div
   {:class (uu/cm "flex flex-col gap-3")}
   [:div "Result: "]
   [result/result
    {:hit {:id "matching-id"
           :title "Matching Entity"}
     :tab-index 40
     :on-click (fn [id]
                 (prn "clicked" id))}]
   [result/result
    {:dom-id "recent-search-2"
     :hit {:id "another-matching-id"
           :title "Another Matching Entity"}
     :tab-index 42
     :active? true
     :on-click (fn [id]
                 (prn "clicked" id))}]])

(defn results-test
  [{:keys [state*]}]
  [:div
   {:class (uu/cm "flex flex-col gap-3")}
   [:div "Results in a container: "]
   [result/result-group
    {:title "Deals"
     :icon-class "fa-handshake"
     :active-id "matching-id"
     :visible-hits [{:id "matching-id"
                     :title "Matching Entity"}
                    {:id "matching-2-id"
                     :title "Another Matching Entity"}]
     :tab-index 40
     :on-click (fn [id]
                 (prn "clicked" id))}]])

(defn view
  []
  (r/with-let [state* (r/atom {:left true
                               :right true
                               :spike {:expanded? true
                                       :show-results? true}})]
    [page/centered
     [:div
      {:class (uu/cm "flex flex-col gap-4")}
      [:div
       {:class (uu/cm "text-lg")}
       "Search-selector"]
      [searchbox-spike {:state* state*}]
      [:div
       {:class (uu/cm "text-lg mt-6 pt-6")}
       "Individual components"]
      [searchbox-test {:state* state*}]
      [expandable-searchbox-test {:state* state*}]
      [recently-selected-test {:state* state*}]
      [recent-search-test {:state* state*}]
      [result-test {:state* state*}]
      [results-test {:state* state*}]]]))
